import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React, { useState } from "react";

import { ProductEntity } from "@/mk2/apps/bazaar/schemas";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { timeAgo } from "@/mk2/helpers/timeformat";
import { QUALITY_VALUES } from "@/mk/bazaar/common/enums";

import styles from "./GridItemHeader.mscss";

interface OwnProps {
    className?: string;
    product: ProductEntity;
    showCreatedTime?: boolean;
    showStarredTime?: boolean;
    isModerator?: boolean;
    checked?: boolean;
    complaintsCount?: number;
}

type Props = OwnProps;

const GridItemHeader: React.FunctionComponent<Props> = ({
    className,
    product,
    showCreatedTime = false,
    isModerator = false,
    complaintsCount,
    checked,
    showStarredTime = false,
}) => {
    const [starrableCreatedTime] = useState(product.starrable && product.starrable.createdTime); // Store to state so that we do not lost date on unstar

    return (
        <div
            className={cx(
                styles.GridItemHeader,
                className,
                styles[`GridItemHeader--${product.quality}`],
            )}
        >
            <span
                className={cx(
                    styles.GridItemHeader__quality,
                    styles[`GridItemHeader__quality--${product.quality}`],
                )}
            >
                {QUALITY_VALUES[product.quality].label}
            </span>
            {isModerator && (
                <>
                    <span
                        className={cx(
                            styles.GridItemHeader__reportStatus,
                            checked && styles["GridItemHeader__reportStatus--checked"],
                        )}
                    >
                        {checked ? "✓" : null}
                    </span>
                    {complaintsCount > 0 && (
                        <span className={styles.GridItemHeader__complaints}>
                            <FontAwesomeIcon icon={faExclamationTriangle} />
                            {complaintsCount}
                        </span>
                    )}
                </>
            )}
            <span className={styles.GridItemHeader__date}>
                {timeAgo(
                    showStarredTime && starrableCreatedTime // There some delay between reindex and DB so starrableCreatedTime can be null
                        ? starrableCreatedTime
                        : showCreatedTime
                          ? product.createdTime
                          : product.startTime,
                    null,
                    true,
                )}
            </span>
        </div>
    );
};

GridItemHeader.displayName = "GridItemHeader";

export default React.memo<Props>(GridItemHeader);

interface PlaceholderOwnProps {
    className?: string;
}

let GridItemHeaderPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ className }) => (
    <div className={cx(styles.GridItemHeader, className)}>
        <span className={styles.GridItemHeader__quality}>
            <LoadingPlaceholder width={73} />
        </span>
        <span className={styles.GridItemHeader__date}>
            <LoadingPlaceholder width={105} />
        </span>
    </div>
);

GridItemHeaderPlaceholder.displayName = "GridItemHeaderPlaceholder";

GridItemHeaderPlaceholder = React.memo<PlaceholderOwnProps>(GridItemHeaderPlaceholder);

export { GridItemHeaderPlaceholder };
